// /src/_features/objectCustomization/api/objectCustomizationApi.js
import { apiRoutes } from "../../../_config/apiRoutes";
import { apiSlice } from "../../../_api/apiSlice";

export const objectCustomizationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllObjectCustomizations: builder.query({
      query: (params) => ({
        url: apiRoutes.objectCustomization.get.path,
        method: apiRoutes.objectCustomization.get.reqType,
        params,
      }),
      providesTags: ["ObjectCustomizations"],
    }),
    addCustomField: builder.mutation({
      query: (params) => ({
        url: apiRoutes.objectCustomization.customFields.path,
        method: apiRoutes.objectCustomization.customFields.reqType,
        body: params,
      }),
      invalidatesTags: ["ObjectCustomizations"],
    }),
    publishCustomFields: builder.mutation({
      query: (params) => ({
        url: apiRoutes.objectCustomization.publishCustomFields.path,
        method: apiRoutes.objectCustomization.publishCustomFields.reqType,
        body: params,
      }),
      invalidatesTags: ["ObjectCustomizations"],
    }),
    discardCustomField: builder.mutation({
      query: (params) => ({
        url: apiRoutes.objectCustomization.discardCustomField.path,
        method: apiRoutes.objectCustomization.discardCustomField.reqType,
        body: params,
      }),
      invalidatesTags: ["ObjectCustomizations"],
    }),
    customFieldStatus: builder.mutation({
      query: (params) => ({
        url: apiRoutes.objectCustomization.customFieldStatus.path,
        method: apiRoutes.objectCustomization.customFieldStatus.reqType,
        body: params,
      }),
      invalidatesTags: ["ObjectCustomizations"],
    }),
    updateCustomField: builder.mutation({
      query: (params) => ({
        url: apiRoutes.objectCustomization.updateCustomField.path,
        method: apiRoutes.objectCustomization.updateCustomField.reqType,
        body: params,
      }),
      invalidatesTags: ["ObjectCustomizations"],
    }),
  }),
});

export const {
  useGetAllObjectCustomizationsQuery,
  useLazyGetAllObjectCustomizationsQuery,
  useAddCustomFieldMutation,
  usePublishCustomFieldsMutation,
  useDiscardCustomFieldMutation,
  useCustomFieldStatusMutation,
  useUpdateCustomFieldMutation,
} = objectCustomizationApiSlice; 